import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

/** This is a base class for all main page components that are included in the root router */
@Component
export class BaseRootPageComponent extends Vue {
  /**
   * Used to set the title in the navbar. This must be explicitly called by each root view component (the ones
   * referenced by the router)
   */
  @Prop(Function) readonly setTitle!: (title?: string | null) => void;
  @Prop() readonly user!: any;
  @Prop() readonly routes!: { path: string; name: string }[];

  created() {
    // Default to setting the title to the route's name
    this.setTitle(this.$route.name);
  }
}
